import { render, staticRenderFns } from "./botInicio.vue?vue&type=template&id=52434080&scoped=true"
import script from "./botInicio.vue?vue&type=script&lang=js"
export * from "./botInicio.vue?vue&type=script&lang=js"
import style0 from "./botInicio.vue?vue&type=style&index=0&id=52434080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52434080",
  null
  
)

export default component.exports